import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  HostBinding,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WINDOW } from '@campus/browser';
import { ENVIRONMENT_API_TOKEN } from '@campus/environment';
import { AuthFacade, LoginCredentials, UserType } from '@campus/public-portal';
import '@diekeure/dcr-components/dcr-dialog.js';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';
import { AppViewModel } from '../../app.viewmodel';
import { LoginFormComponent } from '../../components/login/login-form.component';
@Directive({
  standalone: false,
  selector: '[kabasLoginForm], [loginForm], kabas-login-form',
})
export class LoginFormDirective {
  @HostBinding('class.kabas-login__form')
  hasKabasLoginFormClass = true;
}
@Component({
  standalone: false,
  selector: 'kabas-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  @Input() showQrScanner = false;

  public scanError: string;

  public role$: Observable<UserType>;
  public loginSucceeded$: Observable<boolean>;
  public showEmailSentDialog$ = new BehaviorSubject<boolean>(false);

  private appViewModel = inject(AppViewModel);
  private environmentApi = inject(ENVIRONMENT_API_TOKEN);
  private window: Window = inject(WINDOW);
  private route = inject(ActivatedRoute);
  private auth = inject(AuthFacade);

  private validateUrl(url: string): boolean {
    return url.startsWith(this.environmentApi.APIBase);
  }

  ngOnInit(): void {
    this.loginSucceeded$ = this.auth.isAuthenticated$;
    this.role$ = this.route.params.pipe(map((params) => params.role));
  }

  goToPlatform() {
    this.appViewModel.redirectToPlatform();
  }

  logout() {
    this.auth.logout();
  }

  login(credentials: LoginCredentials) {
    this.auth.login(credentials);
  }

  resetPassword(email: string) {
    this.auth
      .resetPassword(email)
      .pipe(
        take(1),
        tap((success) => {
          if (success) {
            this.showEmailSentDialog$.next(true);
          }
        })
      )
      .subscribe();
  }

  @ViewChild(LoginFormComponent) loginForm: LoginFormComponent;

  onEmailSentDialogConfirm() {
    this.showEmailSentDialog$.next(false);
    if (this.loginForm) {
      this.loginForm.resetTeacherForm();
    }
  }

  onScanResultReceived(result: string): void {
    const apiUrl = this.validateUrl(result);
    if (apiUrl) {
      this.window.location.href = result;
      return;
    }
    this.scanError = 'Deze QR-code is niet geldig';
  }
}
